import { useTranslation } from 'react-i18next';

import { Card, CardHeader } from '@/components/atoms/Card';
import { KeyValueTable } from '@/components/organisms/DataTable';
import type { LastLocation } from '@/domain/bioscopes';
import { formatDateTimeWorded } from '@/utils/date';

interface LastPlacementProps {
    title: string;
    lastLocation: LastLocation;
}

function LastPlacement({ title, lastLocation }: LastPlacementProps) {
    const { t } = useTranslation();

    return (
        <Card as="section" padding="xl" header={<CardHeader title={t(title)} level="h2" />}>
            {!lastLocation ? (
                t('common.labels.nonExistentClient')
            ) : (
                <KeyValueTable
                    rows={[
                        ...(!lastLocation.cage
                            ? [
                                  {
                                      key: 'location',
                                      label: t('common.labels.location'),
                                      value: t('common.labels.onLand'),
                                  },
                              ]
                            : [
                                  {
                                      key: 'facility',
                                      label: t('atoms.lastPlacement.facility'),
                                      value: lastLocation.cage.location?.name,
                                  },
                                  {
                                      key: 'cage',
                                      label: t('common.labels.cage'),
                                      value: lastLocation.cage.name,
                                  },
                              ]),
                        {
                            key: 'from',
                            label: t('common.labels.from'),
                            value: formatDateTimeWorded(lastLocation.from, 'minute'),
                        },
                    ]}
                />
            )}
        </Card>
    );
}

export default LastPlacement;
export { LastPlacement };
